//NPM LIBRARIES
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col} from 'reactstrap';
//REDUX ACTIONS AND SELECTORS
import {verifyStudentDetails, VERIFY_STUDENT_SUCCESS} from '../../../FormStore/Actions/FormServiceActions/MplFormServices/StudentVerificationAction'
//COMPONENTS AND UTILITIES
import {addPageAlert, clearPageAlert} from '../../../PortalStore/Actions/PageAlertActions'
import {AUcallout} from '@gov.au/callout';
import StepNavigation from '../../../components/CASAForm/StepNavigation'
import IndividualLookup from '../../../components/CASAForm/QuestionGroups/IndividualLookup';
import {addStudent} from '../../../FormStore/Actions/FormDataActions/MPL/AddMPLFormData'
import {MPLStudentDetailsVariations} from './MPLStudentDetailsVariations/MPLStudentDetailsVariations'
import CasaSpinner from '../../../components/Portal/CASASpinner';
import {getFormDataSelector, getFormServiceStatusSelector} from "../../../FormStore/Selectors/FormDataSelectors";
import {validateStep} from "../../../components/CASAForm/Utilities";
import CustomBackLink from "../../../components/CASAForm/ReusableQuestions/CustomBackLink";

class MPLAddStudent extends Component {
    constructor(props) {
        super(props);

        let studentArn = ''
        let studentFirstName = ''
        let studentFamilyName = ''
        let studentFullName = ''
        let currentStep = 'verifyStudent'
        let additionalDetails = {}

        if (props.properties.student) {
            studentArn = props.properties.student.studentArn
            studentFirstName = props.properties.student.studentFirstName
            studentFamilyName = props.properties.student.studentFamilyName
            studentFullName = props.properties.student.studentFullName
            currentStep = 'studentDetails'
            additionalDetails = props.properties.student.additionalDetails
        }

        this.state = {
            pageDisplay: currentStep,
            studentFirstName: studentFirstName,
            studentFamilyName: studentFamilyName,
            studentFullName: studentFullName,
            studentArn: studentArn,
            studentValidated: false,
            additionalDetails: additionalDetails,
            showFileUpload: false,
            verifyingStudent: false,
            showError: false
        }
    }

    returnStudentDetails = (returnedQuestion) => {
        if (returnedQuestion.id === "studentFamilyName") {
            this.setState({
                studentFamilyName: returnedQuestion.answer.value
            })
        } else if (returnedQuestion.id === "studentArn") {
            this.setState({
                studentArn: returnedQuestion.answer.value
            })
        }
    };

    returnAdditionalDetails = (returnedQuestion) => {
        let updatedAdditionalDetails = this.state.additionalDetails;

        const hasNoCheckboxValues = returnedQuestion.answer.checkboxValues?.length === 0;
        if (hasNoCheckboxValues) {
            delete updatedAdditionalDetails[returnedQuestion.id];
        }
        else {
            updatedAdditionalDetails[returnedQuestion.id] = returnedQuestion;
        }

        this.setState({
            additionalDetails: updatedAdditionalDetails
        })
    };

    removeAdditionalQuestion = (questionId) => {
        let updatedQuestions = this.state.additionalDetails

        if (updatedQuestions) {
            delete updatedQuestions[questionId]
            this.setState({
                additionalDetails: updatedQuestions
            })
        }
    }

    showHideFileUpload = (radioOption) => {
        if (radioOption.radioValue === 'yes') {
            this.setState({showFileUpload: true})
            return
        }

        this.setState({showFileUpload: false})
    }

    verifyStudentDetails = () => {
        const webappurlForms = this.props.B2CSettings.items.webappurlFormsApi;
        this.setState({verifyingStudent: true})

        this.props.dispatch(
            verifyStudentDetails(webappurlForms, this.props.B2CSettings.items.accesstokenForms, this.state.studentArn, this.state.studentFamilyName)
        )
            .then(response => {
                if (response.type === VERIFY_STUDENT_SUCCESS) {
                    this.setState({
                        verifyingStudent: false,
                        pageDisplay: 'studentDetails',
                        studentFirstName: response.payload.firstName,
                        studentFullName: response.payload.firstName + " " + response.payload.familyName
                    })
                } else {
                    this.setState({verifyingStudent: false})
                    this.props.dispatch(
                        addPageAlert({
                            level: "error",
                            title: "Applicant not found",
                            message: "Please check the applicant's details and try again"
                        })
                    );
                }
            });
    }

    checkDuplicateStudent = () => {
        let studentsInApplication = this.props.formData.students;
        return Object.keys(studentsInApplication).filter((arn) => arn === this.state.studentArn).length === 0;
    }

    nextStep = () => {
        if (this.state.pageDisplay === 'verifyStudent') {
            let errorMessageTitle = "",
                errorMessageText = "";

            if (!(this.state.studentArn && this.state.studentFamilyName)) {
                errorMessageTitle = "There was a problem with the form";
                errorMessageText = "Please check the form below and try again";
                this.setState({showError: true});
            } else if (!this.checkDuplicateStudent()) {
                errorMessageTitle = "Cannot add student";
                errorMessageText = "Student is already on the list";
            }

            if (!errorMessageTitle) {
                this.setState({showError: false});
                this.verifyStudentDetails();
                this.props.dispatch(clearPageAlert());
            } else {
                this.props.dispatch(addPageAlert({
                    level: "error",
                    title: errorMessageTitle,
                    message: errorMessageText
                }));
            }
        } else {
            const errorMessage = validateStep(this.state.additionalDetails);
            if (errorMessage && errorMessage != "") {
                this.setState({showError: true});
                this.props.dispatch(addPageAlert({
                    level: "error",
                    title: "There was a problem with the form",
                    message: "Please check the form below and try again"
                }));
            } else {
                this.setState({showError: false});
                this.props.dispatch(addStudent({
                    studentArn: this.state.studentArn,
                    studentFirstName: this.state.studentFirstName,
                    studentFamilyName: this.state.studentFamilyName,
                    additionalDetails: this.state.additionalDetails,
                    studentFullName: this.state.studentFullName
                }))
                this.props.dispatch(addPageAlert({level: "success", title: "Student added to notification"}));
                this.props.onNextClick()
            }
        }
    }

    previousStep = (e) => {
        e.preventDefault();

        if (this.state.pageDisplay === 'studentDetails') {
            this.props.clearForm();
        } else {
            this.props.pageAlert?.level && this.props.dispatch(clearPageAlert());
            this.props.onPreviousClick();
        }
    }

    createStudentPageCallout = () => {
        if (this.props.properties.isRemovalCategory && this.state.pageDisplay === 'verifyStudent') {
            return (
                <AUcallout
                    title="Removal details"
                    srOnlyTitle>
                    <h3>Removal details</h3>
                    <p>This notification will cover removal of exclusion for category only, you can add multiple
                        students to one notification.</p>
                    <p>However, if you wish to submit a seperate notification for removal of exclusion for type, you
                        will need to complete the submission for removal of exclusion for category before attempting to
                        notify CASA of removal of exclusion for type.</p>
                </AUcallout>
            )
        }
        return (
            <AUcallout
                title={this.state.pageDisplay === 'studentDetails' ? "Student details" : "Course details"}
                srOnlyTitle>
                <h4>{this.state.pageDisplay === 'studentDetails' ? "Student details" : "Course details"}</h4>
                <p>
                    {this.state.pageDisplay === 'studentDetails' &&
                    <Fragment>
                        <strong>Name:</strong> {this.state.studentFullName} <br/>
                        <strong>ARN:</strong> {this.state.studentArn} <br/>
                    </Fragment>
                    }
                    {this.props.properties.removalType &&
                    <Fragment><strong>Removal of Exclusion:</strong> {this.props.properties.removalType.label}<br/></Fragment>
                    }
                    {this.props.properties.courseCode &&
                    <Fragment><strong>Course code:</strong> {this.props.properties.courseCode}<br/></Fragment>
                    }
                    {this.props.properties.courseDescription &&
                    <Fragment><strong>Course identified:</strong> {this.props.properties.courseDescription}<br/></Fragment>
                    }
                </p>
            </AUcallout>
        )
    }

    displayScreen = () => {
        if (this.state.pageDisplay === 'verifyStudent') {
            return (
                <Fragment>
                    <Col
                        className="float-none"
                        lg={6} md={6}>
                        {this.createStudentPageCallout()}
                    </Col>

                    <IndividualLookup
                        headerTitle="Student details"
                        familyNameId="studentFamilyName"
                        familyNameLabel="Student family name"
                        arnId="studentArn"
                        arnLabel="Student aviation reference number"
                        showError={this.state.showError}
                        returnAnswer={this.returnStudentDetails}
                        existingAnswers={{
                            familyName: this.props.properties?.student?.studentFirstName ?? "",
                            arn: this.props.properties?.student?.studentArn ?? ""
                        }}/>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    {this.createStudentPageCallout()}

                    <h3>{this.props.properties.isRemovalCategory ? "Course removal details" : "Course details"}</h3>

                    <MPLStudentDetailsVariations
                        courseOutcome={this.props.properties.removalType?.value === "category" ? "categoryRemoval" : this.props.properties.courseOutcome}
                        returnAdditionalDetails={this.returnAdditionalDetails}
                        existingAnswers={this.state.additionalDetails}
                        removeQuestionData={this.removeAdditionalQuestion}
                        showFileUpload={this.state.showFileUpload}
                        showHideFileUpload={this.showHideFileUpload}
                        showError={this.state.showError}
                        props={this.props}/>
                </Fragment>
            )
        }
    }

    render() {
        return (
            <div id={this.props.id}>
               <CustomBackLink
                    id="previousStep"
                    action={this.previousStep}
                    text="Back"
                    direction="left"/>
                {this.state.verifyingStudent && <CasaSpinner message="Verifying name"/>}
                {this.displayScreen()}

                <div className="form-controls au-form-group">
                    <StepNavigation
                        type="next"
                        label={this.state.pageDisplay === 'verifyStudent' ? 'Next' : 'Save student'}
                        action={this.nextStep}/>
                </div>
            </div>
        )

    }
}

MPLAddStudent.propTypes = {
    properties: PropTypes.object,
    id: PropTypes.string,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    dispatch: PropTypes.func,
    envdata: PropTypes.object,
    B2CSettings: PropTypes.object,
    ClientApp: PropTypes.object,
    clearForm: PropTypes.func,
    formData: PropTypes.object,
    pageAlert: PropTypes.object,
    esbReferenceData: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        envdata: state.envdata,
        B2CSettings: state.B2CSettings,
        ClientApp: state.ClientApp,
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        esbReferenceData: getFormServiceStatusSelector(state.formStore, 'esbReferenceData'),
        pageAlert: state.pageAlert
    }
}

export default connect(mapStateToProps)(MPLAddStudent);